import { FeedItem } from '../../../types/feed.types';
import Card from '../card';
import { MediaCardBody } from './feed-card/body.feedCard';
import { Citation, MediaCardFooter } from './feed-card/footer.feedCard';
import { MediaCardHeader } from './feed-card/header.feedCard';

type FeedCardProps = {
  data: FeedItem;
};

const styles = {
  container:
    'rounded-xl relative w-full min-h-[525px] flex flex-col justify-between rounded-xl border-2 border-dark-gray',
  header: 'p-3',
  footer:
    'px-3 py-3 bg-black/20 backdrop-blur-xl rounded-b-xl flex flex-col gap-y-5',
};

export default function MediaCard(props: FeedCardProps) {
  const { data } = props;
  return (
    <div className="w-full">
      <Card backgroundImage={data.imageUrl} className={styles.container}>
        <Card.Header className={styles.header}>
          <MediaCardHeader
            id={data.id}
            avatarUrl={data.avatar}
            source={data.source}
            sourceUrl={data.sourceUrl}
          />
        </Card.Header>
        <Card.Footer className={styles.footer}>
          <MediaCardBody
            title={data.title || ''}
            comment={data.comment || ''}
            tags={data.tags}
          />
          <MediaCardFooter
            articleId={data.id}
            articleLink={data.link}
            isBookmarked={data.bookmarked || false}
          />
        </Card.Footer>
      </Card>
      {data.type === 'external' && <Citation text={data.source} />}
    </div>
  );
}
